import { GenericBackendResponse } from '../../genericBackendResponse';
import { IndexaToken } from './interfaces/IndexaToken';

const getIndexaToken = async (token: string): Promise<GenericBackendResponse<IndexaToken>> => {
	try {
		const response = await fetch(`${process.env.REACT_APP_BASE_API}/thirdparty/indexa/token`, {
			method: 'GET',
			headers: {
				'Content-Type': 'application/json',
				Authorization: `Bearer ${token}`
			}
		});

		const responseData = await response.json();

		return responseData;
	} catch (error) {
		console.error('Error getting Indexa token:', error);
		return {
			success: false,
			data: {} as IndexaToken,
			code: 500,
			responseAt: new Date().toISOString(),
			debugId: 'indexa-token-get-error',
			message: 'Error al obtener el token de Indexa Capital'
		};
	}
};

export default getIndexaToken;
